var _a, _b, _c, _d, _e, _f;
import { treeItemClasses } from '@mui/lab/TreeItem';
import { neutral60opacity05 } from '../../../colors/neutral';
import { listStyles } from './MuiListItem';
import { MuiTreeView } from './MuiTreeView';
export var MuiTreeItem = {
    styleOverrides: {
        root: (_a = {},
            _a["& .".concat(treeItemClasses.label)] = {
                fontWeight: 'inherit',
                color: 'inherit',
                '& .MuiTreeItemLabel-root': {
                    display: 'flex',
                    alignItems: 'center',
                    padding: 4,
                    paddingInlineEnd: 0,
                },
                '& .MuiTreeItemLabel-icon': { marginInlineEnd: 12 },
                '& .MuiTreeItemLabel-text': {
                    flexGrow: 1,
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    '& .MuiTreeItemLabel-textSecondary': {
                        marginInlineStart: 4,
                        fontWeight: 400,
                    },
                },
                '& .MuiTreeItemLabel-info': { fontSize: '0.775rem' },
            },
            _a),
    },
    customOverrides: {
        small: (_b = {},
            // Copy styles from treeView, but we need to change selector.
            _b["&.".concat(treeItemClasses.root)] = (_c = {},
                _c["& > .".concat(treeItemClasses.content)] = MuiTreeView.customOverrides.small["& .".concat(treeItemClasses.root)]["& .".concat(treeItemClasses.content)],
                _c),
            _b),
        large: (_d = {},
            _d["&.".concat(treeItemClasses.root)] = (_e = {},
                _e["& > .".concat(treeItemClasses.content)] = MuiTreeView.customOverrides.large["& .".concat(treeItemClasses.root)]["& .".concat(treeItemClasses.content)],
                _e),
            _d),
        filled: (_f = {},
            _f["&.".concat(treeItemClasses.root, " > .").concat(treeItemClasses.content, ":not(.").concat(treeItemClasses.selected, ")")] = {
                backgroundColor: neutral60opacity05,
                '&:hover': {
                    backgroundColor: listStyles.hover.backgroundColor,
                },
            },
            _f),
    },
};
